import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import { about } from '../../data'
import './Contact.css'

const Contact = () => {
  const { social, resume } = about

  return (
    <section className='section contact center' id='contact'>
      <div className='contact__panel'>
        <p className='contact__eyebrow'>Open for collaboration</p>
        <h2 className='section__title'>Contact</h2>
        <h4 className='p-contact'>
          Available for product engineering, developer tooling, and founder-led collaborations.
        </h4>
        <div className='contact__actions'>
          {resume && (
            <a href={resume} target='_blank' rel='noreferrer' className='btn btn--outline'>
              Resume
            </a>
          )}
        </div>
        <div className='contact__icons'>{social && (
          <>
            {social.github && (
              <a
                href={social.github}
                aria-label='github'
                className='link link--icon link-contact'
                target='_blank'
                rel='noreferrer'
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label='linkedin'
                className='link link--icon'
                target='_blank'
                rel='noreferrer'
              >
                <LinkedInIcon />
              </a>
            )}
          </>
        )}</div>
      </div>
    </section>
  )
}

export default Contact
